export const TOOLTIP_HOVER_DELAY_MS = 100
